import * as React from "react";

function SvgUserLeap(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path fill="#fff" d="M0 0h53v53H0z" />
      <path
        d="M8.878 17.55C28.035 3.67 44 17.55 44 17.55"
        stroke="#543EDB"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.614 23.202h-2.696v9.588c0 3.77-1.523 5.393-4.57 5.393-3.096 0-4.619-1.648-4.619-5.393v-9.588h-2.771v9.538c0 5.418 2.272 7.99 7.266 7.99 5.043 0 7.39-2.747 7.39-7.99v-9.538zm6.892 0h-2.87V40.43H40.92v-2.743h-7.414V23.203z"
        fill="#252134"
      />
    </svg>
  );
}

export default React.forwardRef(SvgUserLeap);
